import * as React from 'react';
import { ProjectLinkModel } from '../../../../models'
import { EnumHelpers } from '../../../helpers';
import { ProjectViews } from '../../abstract';
// tslint:disable-next-line:ordered-imports
import { Views } from '../../../abstract';

interface IDashboardProjectLinkAddEditViewProps extends Interfaces.IViewProps {
    onSave: () => void
}


class DashboardProjectLinkAddEditView<P, S> extends ProjectViews.CommonView<P & IDashboardProjectLinkAddEditViewProps, S> {

    constructor(props: any) {
        super(props);
    }

    public onSelect(sItems: any, fName: string) {
        this.clearErrorLabel();
        const { model } = this.state;
        model[fName] = sItems?sItems.value:null;
        this.setState({ model });
    }

    public validateForm() {
        const { onSave } = this.props;
        const { model } = this.state;
        if (model['name']) {
            if (model['link']) {
                if (model['type'] >= 0) {
                    onSave();
                } else {
                    this.setState({ error: 'Выберите тип ссылки!' })
                }
            } else {
                this.setState({ error: 'Заполните ссылку!' })
            }
        } else {
            this.setState({ error: 'Заполните наименование!' })
        }
    }

    public renderFullWidthSide() {
        const { model } = this.state;
        return (
            <React.Fragment>
                <Views.TextField
                    floatingLabelText="Наименование проектной ссылки"
                    fullWidth={true}
                    name="name"
                    data-field-type="nml"
                    value={model['name'] || ''}
                    onChange={(e) => this.onTextChange(e)}
                />
                <Views.TextField
                    data-field-type="nml"
                    floatingLabelText="Ссылка"
                    fullWidth={true}
                    name="link"
                    value={model['link'] || ''}
                    onChange={(e) => this.onTextChange(e)}
                />
                <Views.Select
                    name="select"
                    multi={false}
                    searchable={false}
                    placeholder="Тип ссылки"
                    onChange={(o: any) => this.onSelect(o, 'type')}
                    options={EnumHelpers.enumToArray(ProjectLinkModel.Types).map(o => ({ label: o.key, value: o.value }))}
                    value={model['type'] >= 0?{label:ProjectLinkModel.Types[model['type']],value:model['type']}:null}
                />
            </React.Fragment>
        )
    }

}

export default DashboardProjectLinkAddEditView;



// WEBPACK FOOTER //
// ./src/app/dashboard/projectlinks/addedit/ProjectLinksAddEditView.tsx